import { all, call, put, takeLatest, takeLeading } from "redux-saga/effects";
import * as dataDictionaryActions from "./actions";
import {
  CreateDataDictionary,
  CreateDataPointJiraTicket,
  FetchADataPoint,
  FetchADataPointsLogs,
  FetchDataDictionaryList,
  FetchDataDictionaryVersion,
  UpdateDatapointManagement,
  FetchDatapointManagementList,
  FetchDataDictionaryListV2,
  FetchADataPointV2,
  CreateDataDictionaryV2,
  CreateDataPointJiraTicketV1,
  FetchDatapointManagementListV1,
  UpdateDatapointManagementV1,
} from "./services";

export function* fetchDataDictionaryListSaga(action) {
  try {
    const response = yield call(FetchDataDictionaryList, action.payload);
    const dataDictionary = response.data !== null ? response.data : [];
    yield put(
      dataDictionaryActions.FetchDataDictionaryListSuccess(dataDictionary),
    );
  } catch (error) {
    yield put(dataDictionaryActions.FetchDataDictionaryListFailed(error));
  }
}
export function* fetchADataPointSaga(action) {
  try {
    const response = yield call(FetchADataPoint, action.payload);
    if (response.data && response.data.success) {
      yield put(
        dataDictionaryActions.FetchADataPointSuccess(response.data.data.result),
      );
    }
  } catch (error) {
    yield put(dataDictionaryActions.FetchADataPointFailed(error));
  }
}
export function* fetchDataDictionaryVersionSaga(action) {
  try {
    const response = yield call(FetchDataDictionaryVersion, action.payload);
    if (response.data && response.data.success) {
      yield put(
        dataDictionaryActions.FetchDataDictionaryVersionSuccess(
          response.data.data.result,
        ),
      );
    }
  } catch (error) {
    yield put(dataDictionaryActions.FetchDataDictionaryVersionFailed(error));
  }
}
export function* createDataDictionarySaga(action) {
  try {
    const response = yield call(CreateDataDictionary, action.payload);
    if (response && response.data && response.data.success) {
      yield put(
        dataDictionaryActions.CreateDataDictionarySuccess(response.data),
      );
    } else {
      yield put(
        dataDictionaryActions.CreateDataDictionaryFailed(response.data),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(dataDictionaryActions.CreateDataDictionaryFailed(error));
  }
}

export function* fetchADataPointLogsSaga(action) {
  try {
    const response = yield call(FetchADataPointsLogs, action.payload);
    if (response && response.data && response.data.success) {
      yield put(
        dataDictionaryActions.FetchADataPointLogsSuccess(response.data),
      );
    } else {
      yield put(dataDictionaryActions.FetchADataPointLogsFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(dataDictionaryActions.FetchADataPointLogsFailed(error));
  }
}
export function* fetchDataPointManagementListSaga(action) {
  try {
    const response = yield call(FetchDatapointManagementList, action.payload);
    if (response && response.data && response.data.success) {
      yield put(
        dataDictionaryActions.FetchDatapointManagementListSuccess(
          response.data,
        ),
      );
    } else {
      yield put(
        dataDictionaryActions.FetchDatapointManagementListFailed(response.data),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(dataDictionaryActions.FetchDatapointManagementListFailed(error));
  }
}
export function* fetchAuthoredListSaga(action) {
  try {
    const response = yield call(FetchDatapointManagementList, action.payload);
    if (response && response.data && response.data.success) {
      yield put(dataDictionaryActions.FetchAuthoredListSuccess(response.data));
    } else {
      yield put(dataDictionaryActions.FetchAuthoredListFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(dataDictionaryActions.FetchDatapointManagementListFailed(error));
  }
}
export function* updateDatapointManagmentSaga(action) {
  try {
    const response = yield call(UpdateDatapointManagement, action.payload);
    if (response && response.data && response.data.success) {
      yield put(
        dataDictionaryActions.UpdatDataPointManagementSuccess(response.data),
      );
    } else {
      yield put(
        dataDictionaryActions.UpdatDataPointManagementFailed(response.data),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(dataDictionaryActions.UpdatDataPointManagementFailed(error));
  }
}
export function* CreateDataPointJiraTicketSaga(action) {
  try {
    const response = yield call(CreateDataPointJiraTicket, action.payload);
    if (response && response.data && response.data.success) {
      yield put(
        dataDictionaryActions.CreateDataPointJiraTicketSuccess(response.data),
      );
    } else {
      yield put(
        dataDictionaryActions.CreateDataPointJiraTicketFailed(response.data),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    const message =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : error;
    yield put(dataDictionaryActions.CreateDataPointJiraTicketFailed(message));
  }
}
export function* createDataDictionaryV2Saga(action) {
  try {
    const response = yield call(CreateDataDictionaryV2, action.payload);
    if (response && response.data && response.data.success) {
      yield put(
        dataDictionaryActions.CreateDataDictionaryV2Success(response.data),
      );
    } else {
      yield put(
        dataDictionaryActions.CreateDataDictionaryV2Failed(response.data),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(dataDictionaryActions.CreateDataDictionaryV2Failed(error));
  }
}
export function* fetchDataDictionaryListSagaV2(action) {
  try {
    const response = yield call(FetchDataDictionaryListV2, action.payload);
    const dataDictionary = response.data !== null ? response.data : [];
    yield put(
      dataDictionaryActions.FetchDataDictionaryListSuccessV2(dataDictionary),
    );
  } catch (error) {
    yield put(dataDictionaryActions.FetchDataDictionaryListFailedV2(error));
  }
}
export function* fetchADataPointSagaV2(action) {
  try {
    const response = yield call(FetchADataPointV2, action.payload);
    if (response.data && response.data.success) {
      yield put(
        dataDictionaryActions.FetchADataPointSuccessV2(response.data.data),
      );
    }
  } catch (error) {
    yield put(dataDictionaryActions.FetchADataPointFailedV2(error));
  }
}
export function* CreateDataPointJiraTicketSagaV1(action) {
  try {
    const response = yield call(CreateDataPointJiraTicketV1, action.payload);
    if (response && response.data && response.data.success) {
      yield put(
        dataDictionaryActions.CreateDataPointJiraTicketSuccessV1(response.data),
      );
    } else {
      yield put(
        dataDictionaryActions.CreateDataPointJiraTicketFailedV1(response.data),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    const message =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : error;
    yield put(dataDictionaryActions.CreateDataPointJiraTicketFailedV1(message));
  }
}
export function* fetchAuthoredListSagaV1(action) {
  try {
    const response = yield call(FetchDatapointManagementListV1, action.payload);
    if (response && response.data && response.data.success) {
      yield put(
        dataDictionaryActions.FetchAuthoredListSuccessV1(response.data),
      );
    } else {
      yield put(dataDictionaryActions.FetchAuthoredListFailedV1(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(
      dataDictionaryActions.FetchDatapointManagementListFailedV1(error),
    );
  }
}
export function* fetchDataPointManagementListSagaV1(action) {
  try {
    const response = yield call(FetchDatapointManagementListV1, action.payload);
    if (response && response.data && response.data.success) {
      yield put(
        dataDictionaryActions.FetchDatapointManagementListSuccessV1(
          response.data,
        ),
      );
    } else {
      yield put(
        dataDictionaryActions.FetchDatapointManagementListFailedV1(
          response.data,
        ),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(
      dataDictionaryActions.FetchDatapointManagementListFailedV1(error),
    );
  }
}
export function* updateDatapointManagmentSagaV1(action) {
  try {
    const response = yield call(UpdateDatapointManagementV1, action.payload);
    if (response && response.data && response.data.success) {
      yield put(
        dataDictionaryActions.UpdatDataPointManagementSuccessV1(response.data),
      );
    } else {
      yield put(
        dataDictionaryActions.UpdatDataPointManagementFailedV1(response.data),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(dataDictionaryActions.UpdatDataPointManagementFailedV1(error));
  }
}
export function* fetchMoreDataDictionaryListSagaV2(action) {
  try {
    const response = yield call(FetchDataDictionaryListV2, action.payload);
    const dataDictionary = response.data !== null ? response.data : [];
    yield put(
      dataDictionaryActions.FetchMoreDataDictionaryListSuccessV2(
        dataDictionary?.data?.result,
      ),
    );
  } catch (error) {
    yield put(dataDictionaryActions.FetchMoreDataDictionaryListFailedV2(error));
  }
}
export function* dataDictionaryWatcher() {
  yield all([
    takeLatest(
      dataDictionaryActions.types.DATA_DICTIONARY_LIST,
      fetchDataDictionaryListSaga,
    ),
    takeLatest(
      dataDictionaryActions.types.FETCH_A_DATA_DICTIONARY,
      fetchADataPointSaga,
    ),
    takeLatest(
      dataDictionaryActions.types.FETCH_DATA_DICTIONARY_VERSION,
      fetchDataDictionaryVersionSaga,
    ),
    takeLeading(
      dataDictionaryActions.types.CREATE_DATA_DICTIONARY,
      createDataDictionarySaga,
    ),
    takeLatest(
      dataDictionaryActions.types.FETCH_A_DATA_POINT_LOGS,
      fetchADataPointLogsSaga,
    ),
    takeLatest(
      dataDictionaryActions.types.UPDATE_DATAPOINT_MANAGEMENT,
      updateDatapointManagmentSaga,
    ),
    takeLatest(
      dataDictionaryActions.types.FETCH_DATA_POINT_MANAGEMENT_LIST,
      fetchDataPointManagementListSaga,
    ),
    takeLatest(
      dataDictionaryActions.types.FETCH_AUTHORED_LIST,
      fetchAuthoredListSaga,
    ),
    takeLatest(
      dataDictionaryActions.types.CREATE_DATAPOINT_JIRA_TICKET,
      CreateDataPointJiraTicketSaga,
    ),
    takeLatest(
      dataDictionaryActions.types.DATA_DICTIONARY_LIST_V2,
      fetchDataDictionaryListSagaV2,
    ),
    takeLatest(
      dataDictionaryActions.types.FETCH_A_DATA_DICTIONARY_V2,
      fetchADataPointSagaV2,
    ),
    takeLeading(
      dataDictionaryActions.types.CREATE_DATA_DICTIONARY_V2,
      createDataDictionaryV2Saga,
    ),
    takeLatest(
      dataDictionaryActions.types.CREATE_DATAPOINT_JIRA_TICKET_V1,
      CreateDataPointJiraTicketSagaV1,
    ),
    takeLatest(
      dataDictionaryActions.types.FETCH_DATA_POINT_MANAGEMENT_LIST_V1,
      fetchDataPointManagementListSagaV1,
    ),
    takeLatest(
      dataDictionaryActions.types.FETCH_AUTHORED_LIST_V1,
      fetchAuthoredListSagaV1,
    ),
    takeLatest(
      dataDictionaryActions.types.UPDATE_DATAPOINT_MANAGEMENT_V1,
      updateDatapointManagmentSagaV1,
    ),
    takeLatest(
      dataDictionaryActions.types.FETCH_MORE_DATA_DICTIONARY_LIST_V2,
      fetchMoreDataDictionaryListSagaV2,
    ),
  ]);
}
